import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { SystemFlow } from './SystemFlow';
import { getWhatsAppLink } from '../../utils/whatsapp';
const HERO_WHATSAPP_MESSAGE = 'Hola, equipo de Origen Studio. Quiero conocer más sobre sus sistemas de presencia digital y automatización con IA.';
export function Hero() {
  return <section className="min-h-[100vh] pt-[72px] bg-arena flex items-center" data-id="element-216" data-mp="eoathce3kh8e">
      <div className="max-w-[1200px] mx-auto w-full px-6 md:px-20 py-14 md:py-0" data-id="element-217" data-mp="apv26wazgmp6">
        <div className="grid grid-cols-1 md:grid-cols-[55%_45%] gap-16 md:gap-8 items-center min-h-[calc(100vh-72px)]" data-id="element-218" data-mp="5onpcitzgxbn">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="flex flex-col items-start" data-id="element-219" data-mp="3rwx4lma6nknt">
            <span className="font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-4" data-id="element-220" data-mp="1muriqq6k284i">
              PRESENCIA DIGITAL + AUTOMATIZACIÓN CON IA
            </span>

            <h1 className="font-display text-[40px] md:text-[64px] font-bold text-carbon leading-[1.08] tracking-[-0.02em] max-w-[560px] mb-6" data-id="element-221" data-mp="1czgbesxh836s">
              Tu empresa no necesita más herramientas.
              <br data-id="element-222" data-mp="25o5361cn6w5v" />
              Necesita que trabajen juntas.
            </h1>

            <p className="font-body text-[18px] md:text-[20px] text-carbon/65 leading-[1.6] max-w-[480px] mb-10" data-id="element-223" data-mp="2am6nsqppv3jg">
              Construimos presencia digital y automatizaciones con IA para
              que tu empresa atienda, convierta y haga seguimiento sin
              depender de procesos manuales.
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto" data-id="element-224" data-mp="2okwmubw3jdag">
              <a href="#precios" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[15px] px-7 py-3.5 rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-225" data-mp="2tdpous06k7iu">
                Ver soluciones <ArrowRight size={16} className="ml-2" data-id="element-226" data-mp="2p8vubcidygzc" />
              </a>
              <a href={getWhatsAppLink(HERO_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-transparent text-carbon border border-carbon/20 font-display font-semibold text-[15px] px-7 py-3.5 rounded-[6px] hover:border-carbon/40 hover:bg-carbon/5 transition-all duration-200" data-id="element-227" data-mp="2payjxvfmm83j">
                Hablar con ORIGEN <ArrowRight size={16} className="ml-2" data-id="element-228" data-mp="21jb2030ce7de" />
              </a>
            </div>
          </motion.div>

          {/* Right Column - Interactive system diagram */}
          <div className="w-full flex items-center justify-center" data-id="element-229" data-mp="c1w7bd4ga7i7">
            <SystemFlow data-id="element-230" data-mp="c1nsvgsoiu4w" />
          </div>
        </div>
      </div>
    </section>;
}